import {Injectable} from '@angular/core';
import {ActionPerformed, PushNotifications, Token} from '@capacitor/push-notifications';
import {PushNotificationSchema} from '@capacitor/push-notifications/dist/esm/definitions';
import {from, Observable, of} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import {Capacitor} from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationsService {

  public initialize(): Observable<boolean> {
    if (!Capacitor.isNativePlatform()) {
      return of(false);
    }
    return this._checkAndRequestPermissions().pipe(
      switchMap((isGranted) => {
        if (isGranted) {
          this._registerPushNotifications();
        } else {
          console.warn('Push notifications permissions not granted.');
        }
        return of(isGranted);
      }),
      catchError((error) => {
        console.error('Error during push notifications initialization:', error);
        return of(false);
      })
    );
  }

  public unregister(): Observable<void> {
    return from(PushNotifications.removeAllListeners()).pipe(
      switchMap(() => {
        return from(PushNotifications.unregister());
      }),
      map(() => {
      }),
      catchError((error) => {
        console.error('Error during push notifications unregistration:', error);
        return of();
      })
    );
  }

  private _checkAndRequestPermissions(): Observable<boolean> {
    return from(PushNotifications.checkPermissions()).pipe(
      switchMap((permission) => {
        if (permission.receive !== 'granted') {
          return from(PushNotifications.requestPermissions()).pipe(
            map((requestResult) => requestResult.receive === 'granted')
          );
        }
        return of(true);
      }),
      catchError((error) => {
        console.error('Error checking/requesting permissions:', error);
        return of(false);
      })
    );
  }

  private _registerPushNotifications(): void {
    PushNotifications.register();

    this._addListenerForRegistration();
    this._addListenerForRegistrationError();
    this._addListenerForNotificationReceived();
    this._addListenerForNotificationActionPerformed();
  }

  private _addListenerForRegistration(): void {
    PushNotifications.addListener('registration', (token: Token) => {
    });
  }

  private _addListenerForRegistrationError(): void {
    PushNotifications.addListener('registrationError', (error: any) => {
      console.error('Push registration error: ', error);
    });
  }

  private _addListenerForNotificationReceived(): void {
    PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
      console.log('Push notifications received: ', notification);
    });
  }

  private _addListenerForNotificationActionPerformed(): void {
    PushNotifications.addListener('pushNotificationActionPerformed', (action: ActionPerformed) => {
    });
  }
}
